import { Autocomplete, Box, TextField, Typography } from "@mui/material";

import { formatPriceHistoryFilterCount } from "./pricingReportProductFilter";

function PricingReportProductFilter({
  options,
  value,
  onChange,
  formatOptionLabel,
  loading = false,
}) {
  return (
    <Autocomplete
      fullWidth
      multiple
      size="small"
      options={options}
      value={value}
      onChange={(_, nextProducts) => onChange(nextProducts)}
      getOptionLabel={(product) => formatOptionLabel(product)}
      isOptionEqualToValue={(left, right) => left?.id === right?.id}
      renderOption={(props, option) => {
        const { key: _ignoredMuiKey, ...listItemProps } = props;
        const countLabel = formatPriceHistoryFilterCount(option.priceHistoryCount);
        return (
          <Box
            component="li"
            key={option.id}
            {...listItemProps}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "space-between",
              gap: 1,
              width: "100%",
            }}
          >
            <Box component="span" sx={{ minWidth: 0, flex: 1 }}>
              {formatOptionLabel(option)}
            </Box>
            {countLabel ? (
              <Typography
                component="span"
                variant="body2"
                color="text.secondary"
                sx={{ flexShrink: 0, fontVariantNumeric: "tabular-nums" }}
              >
                {countLabel}
              </Typography>
            ) : null}
          </Box>
        );
      }}
      renderInput={(params) => <TextField {...params} label="Products" />}
      loading={loading}
    />
  );
}

export default PricingReportProductFilter;
